import { render } from "./WelcomeComponent.vue?vue&type=template&id=42b22323&scoped=true"
import script from "./WelcomeComponent.vue?vue&type=script&lang=js"
export * from "./WelcomeComponent.vue?vue&type=script&lang=js"

import "./WelcomeComponent.vue?vue&type=style&index=0&id=42b22323&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b22323"]])

export default __exports__